import { forwardRef, InputHTMLAttributes } from 'react';
import styles from './Input.module.scss';
import { cn } from '../../../utils/utils';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, id, type = 'text', className, ...inputProps }, ref) => {
    return (
      <div className={styles['input']}>
        <label htmlFor={id} className={styles['label']}>
          {label}
        </label>
        <input
          ref={ref}
          className={cn(styles['form'], error && styles['error'], className)}
          type={type}
          id={id}
          {...inputProps}
        />
        {error ? <span className={styles['error-message']}>{error}</span> : null}
      </div>
    );
  },
);
